export { DMS_MODULE } from '../../constants';
export const NAME = 'ZarazeniPnv';
export const CRUMB_LABEL_KEY = 'edtPNVVaria';
